import { render, staticRenderFns } from "./FileProcessingIllustration.vue?vue&type=template&id=2bd6ec8c&"
import script from "./FileProcessingIllustration.vue?vue&type=script&lang=js&"
export * from "./FileProcessingIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd6ec8c')) {
      api.createRecord('2bd6ec8c', component.options)
    } else {
      api.reload('2bd6ec8c', component.options)
    }
    module.hot.accept("./FileProcessingIllustration.vue?vue&type=template&id=2bd6ec8c&", function () {
      api.rerender('2bd6ec8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/FileProcessingIllustration.vue"
export default component.exports